/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Interview_Prepare_Toast_GeneratedInputs */

const en_interview_prepare_toast_generated = /** @type {(inputs: Interview_Prepare_Toast_GeneratedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interview questions generated`)
};

const de_interview_prepare_toast_generated = /** @type {(inputs: Interview_Prepare_Toast_GeneratedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interviewfragen generiert`)
};

const fr_interview_prepare_toast_generated = /** @type {(inputs: Interview_Prepare_Toast_GeneratedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Questions d'entretien générées`)
};

const es_interview_prepare_toast_generated = /** @type {(inputs: Interview_Prepare_Toast_GeneratedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preguntas de entrevista generadas`)
};

const it_interview_prepare_toast_generated = /** @type {(inputs: Interview_Prepare_Toast_GeneratedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Domande per il colloquio generate`)
};

const nl_interview_prepare_toast_generated = /** @type {(inputs: Interview_Prepare_Toast_GeneratedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sollicitatievragen gegenereerd`)
};

const pl_interview_prepare_toast_generated = /** @type {(inputs: Interview_Prepare_Toast_GeneratedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pytania rekrutacyjne wygenerowane`)
};

const fi_interview_prepare_toast_generated = /** @type {(inputs: Interview_Prepare_Toast_GeneratedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Haastattelukysymykset luotu`)
};

const da_interview_prepare_toast_generated = /** @type {(inputs: Interview_Prepare_Toast_GeneratedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Interviewspørgsmål genereret`)
};

const sv_interview_prepare_toast_generated = /** @type {(inputs: Interview_Prepare_Toast_GeneratedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intervjufrågor genererade`)
};

/**
* | output |
* | --- |
* | "Interview questions generated" |
*
* @param {Interview_Prepare_Toast_GeneratedInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const interview_prepare_toast_generated = /** @type {((inputs?: Interview_Prepare_Toast_GeneratedInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Interview_Prepare_Toast_GeneratedInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_interview_prepare_toast_generated(inputs)
	if (locale === "fr") return fr_interview_prepare_toast_generated(inputs)
	if (locale === "es") return es_interview_prepare_toast_generated(inputs)
	if (locale === "it") return it_interview_prepare_toast_generated(inputs)
	if (locale === "nl") return nl_interview_prepare_toast_generated(inputs)
	if (locale === "pl") return pl_interview_prepare_toast_generated(inputs)
	if (locale === "fi") return fi_interview_prepare_toast_generated(inputs)
	if (locale === "da") return da_interview_prepare_toast_generated(inputs)
	if (locale === "sv") return sv_interview_prepare_toast_generated(inputs)
	return en_interview_prepare_toast_generated(inputs)
});